var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input',_vm._b({attrs:{"type":"text","disabled":_vm.disabled},on:{"blur":function($event){_vm.isInFocus = false},"focus":function($event){_vm.isInFocus = true}},model:{value:(_vm.displayValue),callback:function ($$v) {_vm.displayValue=$$v},expression:"displayValue"}},'b-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }